<template>
    <div class="main_component_container application_solutions_wrapper">
        <section class="flexbox_container full_height">
            <div class="box">
                <header>
                    <comp_query_nav_options></comp_query_nav_options>
                    <!-- CONSULTA GUARDADA -->
                    <h2 class="title">
                        {{ translations.solutions_view.title_view }}
                        <span v-if="App.query.current_query" class="current_query_name">
                            <span class="query_info_title">&#151; {{ translations.generic.query }}</span>
                            {{ App.query.current_query.name }}</span>
                    </h2>

                    <!-- RESULTADOS: Cabecera -->
                    <div class="info_results_application_solutions_table">
                        <span @click="orderBy('work', work_direction)" :class="[{ selected: order_field == 'work' }]"
                            class="solutions">{{ translations.solutions_view.grid_solutions }}
                            <i v-bind:class="[
                                { 'icon-down': work_direction == 'DESC' },
                                { 'icon-up': work_direction == 'ASC' }
                            ]"></i>
                        </span>
                        <span @click="orderBy('year', year_direction)" :class="[{ selected: order_field == 'year' }]"
                            class="year">{{ translations.solutions_view.grid_years }}
                            <i v-bind:class="[
                                { 'icon-down': year_direction == 'DESC' },
                                { 'icon-up': year_direction == 'ASC' }
                            ]"></i>
                        </span>
                        <span @click="orderBy('assembly', assembly_direction)"
                            :class="[{ selected: order_field == 'assembly' }]" class="assembly">{{
                                translations.solutions_view.grid_assembly }}
                            <i v-bind:class="[
                                {
                                    'icon-down':
                                        assembly_direction == 'DESC'
                                },
                                { 'icon-up': assembly_direction == 'ASC' }
                            ]"></i>
                        </span>
                        <span @click="orderBy('application', application_direction)"
                            :class="[{ selected: order_field == 'application' }]" class="application">{{
                                translations.solutions_view.grid_applications }}
                            <i v-bind:class="[
                                {
                                    'icon-down':
                                        application_direction == 'DESC'
                                },
                                {
                                    'icon-up':
                                        application_direction == 'ASC'
                                }
                            ]"></i>
                        </span>
                        <span @click="orderBy('country', country_direction)"
                            :class="[{ selected: order_field == 'country' }]" class="country">{{
                                translations.solutions_view.grid_countries }}
                            <i v-bind:class="[
                                {
                                    'icon-down': country_direction == 'DESC'
                                },
                                { 'icon-up': country_direction == 'ASC' }
                            ]"></i>
                        </span>
                    </div>
                </header>

                <!-- RESULTADOS: Listado -->
                <section>
                    <div @click="singleViewApplicationSolution(application[0].id)"
                        v-for="(  application, key, index  ) in App.query.getSolutionsByObra()" :key="index"
                        class="applications_solution_item">
                        <span class="solutions">
                            <img :style="
                                'background-image: url(' + App.apiUrl + '/' +
                                application[0].solution_image +
                                ')'
                            " class="image" />
                            <div class="title">{{ application[0].name }}</div>
                        </span>
                        <span class="year">{{
                            application[0].year | truncate
                        }}</span>
                        <span class="assembly" v-html="getAssemblies(application)"></span>
                        <span class="application" v-html="getApplications(application)"></span>
                        <span class="country">{{
                            application[0].country
                        }}</span>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
import App from './../application.js'
import comp_query_nav_options from './comp_query_nav_options.vue'

export default {
    components: {
        comp_query_nav_options
    },
    data: function () {
        return {
            App: App,
            translations: {
                generic: App.current_translations['generic'],
                countries: App.current_translations['countries'],
                solutions_view: App.current_translations['solutions_view']
            },
            order_field: 'year',
            work_direction: 'ASC',
            year_direction: 'DESC',
            assembly_direction: 'ASC',
            application_direction: 'ASC',
            country_direction: 'ASC'
        };
    },
    mounted: function () {
        document.title = "UnexApp - " + this.translations.generic.results

        if( App.query.active_search.length == 0 ){
            this.$router.push('/query')
        }
    },
    updated: function () {
        var hh = $('.application_solutions_wrapper .box > header').height();
        $('.application_solutions_wrapper .box > section').height($(window).height() - hh);
    },
    methods: {
        /**
         * Navigate to the selected solution
         */
        singleViewApplicationSolution: function (solutionId) {
            this.$router.push('/solutions/' + solutionId)
        },

        getapplicationSolutions: function () {
            return this.applications_solutions;
        },
        goToFilters: function () {
            this.$router.push('/query')
        },
        getReturn: function (application) {
            return application;
        },
        getAssemblies: function (application) {
            var applications_name = [];
            var result = '';
            for (var i = 0; i < application.length; i++) {
                if (applications_name.indexOf(application[i].assembly) == -1 && application[i].assembly != '-') {
                    applications_name.push(application[i].assembly);
                    result = result + '<span class="application_assembly">' + application[i].assembly + '</span>';
                }
            }
            return result;
        },
        getApplications: function (application) {
            var solution_name = [];
            var result = '';
            for (var i = 0; i < application.length; i++) {
                if (solution_name.indexOf(application[i].application) == -1 && application[i].application != '-') {
                    solution_name.push(application[i].application);
                    result = result + '<span class="application_solution">' + application[i].application + '</span>';
                }
            }
            return result;
        },
        orderBy: function (field, direction) {
            // return ;

            direction = direction == 'ASC' ? 'DESC' : 'ASC';
            this.work_direction = 'ASC';
            this.year_direction = 'ASC';
            this.assembly_direction = 'ASC';
            this.application_direction = 'ASC';
            this.country_direction = 'ASC';
            this[field + '_direction'] = direction;
            this.order_field = field;

            App.query.orderSolutiondBy(field, direction)
        }
    }
}
</script>

<style></style>